import { Event } from "event-system";
import { Container, Graphics, IDestroyOptions } from "pixi.js";

export class WalletsClickableArea extends Container {
    public readonly onClick: Event<void>;

    private readonly leftArea: Graphics;
    private readonly rightArea: Graphics;

    public constructor() {
        super();
        this.onClick = new Event();
        this.leftArea = new Graphics()
            .beginFill(0xFFFFFF, 1)
            .drawRect(0, 0, 174, 165)
            .endFill();
        this.leftArea.alpha = 0;
        this.leftArea.eventMode = 'static';
        this.leftArea.on('pointerdown', this.onAreaClickHandle, this);

        this.rightArea = new Graphics()
            .beginFill(0xFFFFFF, 1)
            .drawRect(0, 0, 200, 165)
            .endFill();
        this.rightArea.alpha = 0;
        this.rightArea.position.x = 382;
        this.rightArea.eventMode = 'static';
        this.rightArea.on('pointerdown', this.onAreaClickHandle, this);

        this.addChild(this.leftArea, this.rightArea);
    }

    private onAreaClickHandle(): void {
        this.onClick.emit();
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.leftArea.off('pointerdown', this.onAreaClickHandle, this);
        this.rightArea.off('pointerdown', this.onAreaClickHandle, this);
        super.destroy(options);
    }
}